import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/design-system.scss';
// 이 서버로 가는 요청에 로그인 토큰 첨부 (계정 바인딩)
import './authInterceptor';
import App from './App';
// 페이지 SCSS 이후에 로드되어야 하는 전역 통일 규칙
import './styles/overrides.scss';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"
import { Reset } from 'styled-reset'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <Reset/>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
